var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "copy-field", class: { password: _vm.password } },
    [
      _vm.password
        ? _c("div", [_vm._v(_vm._s(_vm.formatedPassword))])
        : _c("input", {
            ref: "field",
            attrs: {
              type: _vm.password && !_vm.passwordVisible ? "password" : "text",
              readonly: _vm.editable,
            },
            domProps: { value: _vm.text },
            on: { click: _vm.select },
          }),
      _c("input", {
        ref: "hidden",
        staticClass: "hidden",
        attrs: { type: "text" },
        domProps: { value: _vm.text },
      }),
      _vm.password
        ? _c(
            "button",
            {
              staticClass: "password",
              on: {
                click: function ($event) {
                  _vm.passwordVisible = !_vm.passwordVisible
                },
              },
            },
            [
              _vm.passwordVisible
                ? _c(
                    "svg",
                    {
                      attrs: {
                        width: "20",
                        height: "13",
                        viewBox: "0 0 20 13",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M5.70711 0.292893C5.31658 -0.0976311 4.68342 -0.0976311 4.29289 0.292893C3.90237 0.683417 3.90237 1.31658 4.29289 1.70711L5.70711 0.292893ZM15.2929 12.7071C15.6834 13.0976 16.3166 13.0976 16.7071 12.7071C17.0976 12.3166 17.0976 11.6834 16.7071 11.2929L15.2929 12.7071ZM18 7L18.8129 7.58235L19.2301 7L18.8129 6.41765L18 7ZM2 7L1.18706 6.41765L0.769899 7L1.18706 7.58235L2 7ZM4.29289 1.70711L15.2929 12.7071L16.7071 11.2929L5.70711 0.292893L4.29289 1.70711ZM18 7C17.1871 6.41765 17.1872 6.41744 17.1874 6.41725C17.1874 6.41721 17.1875 6.41703 17.1876 6.41695C17.1877 6.41679 17.1877 6.41671 17.1877 6.4167C17.1878 6.41668 17.1876 6.41696 17.1871 6.41753C17.1863 6.41867 17.1846 6.42098 17.1821 6.42442C17.1771 6.4313 17.1687 6.4427 17.1571 6.45831C17.1338 6.48955 17.0975 6.5376 17.0488 6.60008C16.9513 6.72511 16.8048 6.90733 16.6145 7.12764C16.2328 7.56963 15.6814 8.15767 15.0033 8.7431C13.6162 9.94076 11.847 11 10 11V13C12.5713 13 14.8021 11.5592 16.3104 10.2569C17.0801 9.59233 17.7002 8.93037 18.1281 8.43486C18.3427 8.18642 18.5105 7.97801 18.6262 7.82961C18.684 7.75537 18.729 7.696 18.7603 7.654C18.776 7.63299 18.7882 7.61631 18.797 7.60427C18.8014 7.59825 18.805 7.59339 18.8076 7.58972C18.809 7.58789 18.8101 7.58635 18.8109 7.58512C18.8114 7.58451 18.8118 7.58397 18.8121 7.5835C18.8123 7.58327 18.8125 7.58298 18.8126 7.58287C18.8128 7.5826 18.8129 7.58235 18 7ZM10 11C8.15301 11 6.38378 9.94076 4.99668 8.7431C4.31864 8.15767 3.76722 7.56963 3.38551 7.12764C3.19525 6.90733 3.0487 6.72511 2.95124 6.60008C2.90254 6.5376 2.86621 6.48955 2.84292 6.45831C2.83127 6.4427 2.82289 6.4313 2.81787 6.42442C2.81535 6.42098 2.81368 6.41867 2.81286 6.41753C2.81244 6.41696 2.81224 6.41668 2.81226 6.4167C2.81226 6.41671 2.81232 6.41679 2.81244 6.41695C2.81249 6.41703 2.81262 6.41721 2.81265 6.41725C2.81279 6.41744 2.81294 6.41765 2 7C1.18706 7.58235 1.18724 7.5826 1.18743 7.58287C1.18752 7.58298 1.18772 7.58327 1.18789 7.5835C1.18822 7.58397 1.18861 7.58451 1.18905 7.58512C1.18994 7.58635 1.19104 7.58789 1.19237 7.58972C1.19502 7.59339 1.19855 7.59825 1.20295 7.60427C1.21175 7.61631 1.22402 7.63299 1.23969 7.654C1.27102 7.696 1.31595 7.75537 1.37382 7.82961C1.4895 7.97801 1.65729 8.18642 1.87185 8.43486C2.29978 8.93037 2.91993 9.59233 3.68962 10.2569C5.19795 11.5592 7.42871 13 10 13V11ZM2 7C2.81294 7.58235 2.81279 7.58256 2.81265 7.58275C2.81262 7.58279 2.81249 7.58297 2.81244 7.58305C2.81232 7.58321 2.81226 7.58329 2.81226 7.5833C2.81224 7.58332 2.81244 7.58304 2.81286 7.58247C2.81368 7.58133 2.81535 7.57902 2.81787 7.57558C2.82289 7.5687 2.83127 7.5573 2.84292 7.54169C2.86621 7.51045 2.90254 7.4624 2.95124 7.39992C3.0487 7.27489 3.19525 7.09267 3.38551 6.87236C3.76722 6.43037 4.31864 5.84233 4.99668 5.2569C6.38378 4.05924 8.15301 3 10 3V1C7.42871 1 5.19795 2.44076 3.68962 3.7431C2.91993 4.40767 2.29978 5.06963 1.87185 5.56514C1.65729 5.81358 1.4895 6.02199 1.37382 6.17039C1.31595 6.24463 1.27102 6.304 1.23969 6.346C1.22402 6.36701 1.21175 6.38369 1.20295 6.39573C1.19855 6.40175 1.19502 6.40661 1.19237 6.41028C1.19104 6.41211 1.18994 6.41365 1.18905 6.41488C1.18861 6.41549 1.18822 6.41603 1.18789 6.4165C1.18772 6.41673 1.18752 6.41702 1.18743 6.41713C1.18724 6.4174 1.18706 6.41765 2 7ZM10 3C11.847 3 13.6162 4.05924 15.0033 5.2569C15.6814 5.84233 16.2328 6.43037 16.6145 6.87236C16.8048 7.09267 16.9513 7.27489 17.0488 7.39992C17.0975 7.4624 17.1338 7.51045 17.1571 7.54169C17.1687 7.5573 17.1771 7.5687 17.1821 7.57558C17.1846 7.57902 17.1863 7.58133 17.1871 7.58247C17.1876 7.58304 17.1878 7.58332 17.1877 7.5833C17.1877 7.58329 17.1877 7.58321 17.1876 7.58305C17.1875 7.58297 17.1874 7.58279 17.1874 7.58275C17.1872 7.58256 17.1871 7.58235 18 7C18.8129 6.41765 18.8128 6.4174 18.8126 6.41713C18.8125 6.41702 18.8123 6.41673 18.8121 6.4165C18.8118 6.41603 18.8114 6.41549 18.8109 6.41488C18.8101 6.41365 18.809 6.41211 18.8076 6.41028C18.805 6.40661 18.8014 6.40175 18.797 6.39573C18.7882 6.38369 18.776 6.36701 18.7603 6.346C18.729 6.304 18.684 6.24463 18.6262 6.17039C18.5105 6.02199 18.3427 5.81358 18.1281 5.56514C17.7002 5.06963 17.0801 4.40767 16.3104 3.7431C14.8021 2.44076 12.5713 1 10 1V3ZM12 6C12 7.10457 11.1046 8 10 8V10C12.2091 10 14 8.20914 14 6H12ZM10 8C8.89543 8 8 7.10457 8 6H6C6 8.20914 7.79086 10 10 10V8ZM8 6C8 4.89543 8.89543 4 10 4V2C7.79086 2 6 3.79086 6 6H8ZM10 4C11.1046 4 12 4.89543 12 6H14C14 3.79086 12.2091 2 10 2V4Z",
                          fill: "#8E9CBB",
                        },
                      }),
                    ]
                  )
                : _c(
                    "svg",
                    {
                      attrs: {
                        width: "20",
                        height: "12",
                        viewBox: "0 0 20 12",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M18 6C18 6 14.4183 11 10 11C5.58172 11 2 6 2 6C2 6 5.58172 1 10 1C14.4183 1 18 6 18 6Z",
                          stroke: "#8E9CBB",
                          "stroke-width": "2",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M13 5C13 6.65685 11.6569 8 10 8C8.34315 8 7 6.65685 7 5C7 3.34315 8.34315 2 10 2C11.6569 2 13 3.34315 13 5Z",
                          stroke: "#8E9CBB",
                          "stroke-width": "2",
                        },
                      }),
                    ]
                  ),
            ]
          )
        : _vm._e(),
      _c(
        "button",
        {
          directives: [
            {
              name: "b-popover",
              rawName: "v-b-popover.html",
              value: {
                container: "#app",
                trigger: "hover blur",
                boundary: "window",
                content: "Скопировать в буфер",
                placement: "top",
              },
              expression:
                "{\n      container: '#app',\n      trigger: 'hover blur',\n      boundary: 'window',\n      content: 'Скопировать в буфер',\n      placement: 'top',\n    }",
              modifiers: { html: true },
            },
          ],
          staticClass: "copy",
          on: { click: _vm.copy },
        },
        [_c("svg-icon", { attrs: { name: "copy", size: 16 } })],
        1
      ),
      _vm.success && _vm.successVisible
        ? _c(
            "p",
            { staticClass: "success-message" },
            [
              _c("svg-icon", {
                staticClass: "success-message__icon",
                attrs: { name: "check", color: "success", size: "14" },
              }),
              _vm._v(" " + _vm._s(_vm.success) + " "),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }